import { GeneralContext } from '@f_context/General_context';
import { useMigratedUserLock } from '@f_hooks/useMigratedUserLock';
import { ReactNode, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const MIGRATED_ROUTE = '/app-qwep/migrated';

type MigratedUserGuardProps = {
    children: ReactNode;
};

export function MigratedUserGuard({ children }: MigratedUserGuardProps) {
    const { drawerPanels } = useContext(GeneralContext);
    const { isMigratedLocked, panelsReady } = useMigratedUserLock(drawerPanels);
    const location = useLocation();

    if (panelsReady && isMigratedLocked && location.pathname !== MIGRATED_ROUTE) {
        return <Navigate to={MIGRATED_ROUTE} replace />;
    }

    return <>{children}</>;
}
